export default __webpack_public_path__ + "static/media/Icon_home.ec3bb591.svg";